import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.css';

class ToggleButtons extends React.Component {
  constructor(props) {
    super(props);

    const { options, value } = props;

    this.state = {
      options: props.options,
      value: this.getStartingValue(options, value),
    };
  }

  // eslint-disable-next-line camelcase, react/sort-comp
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.options !== this.state.options ||
      nextProps.value !== this.state.value
    ) {
      this.setState({
        options: nextProps.options,
        value: this.getStartingValue(nextProps.options, nextProps.value),
      });
    }
  }

  getStartingValue = (options, value) => {
    if (typeof value !== 'undefined') {
      return value;
    }
    if (options && options.length) {
      return options[0].value;
    }
  };

  // Adjusts toggle button style based on it's position in the set
  _styleOptions = (i, length) => {
    if (i === 0) {
      return 'Left';
    }
    if (i === length - 1) {
      return 'Right';
    }
    return 'Middle';
  };

  _getClassNames = (option, position, toggleName) => {
    return [
      styles.toggleButton,
      styles[`toggleButton${position}`],
      option.value === this.state.value ? styles.active : '',
      toggleName ? styles.disabled : null,
    ]
      .join(' ')
      .trim();
  };

  _selectOptions = (fnc, value) => {
    this.setState({ value }, () => {
      if (fnc) {
        fnc(this);
      }
    });
  };

  _renderOptions() {
    const options = this.state.options || [];
    const isDisabled = this.props.disabled;
    return options.map((option, index) => {
      return (
        <button
          type="button"
          className={this._getClassNames(
            option,
            this._styleOptions(index, options.length),
            isDisabled,
          )}
          key={option.value}
          onClick={() => {
            if (!isDisabled) {
              this._selectOptions(this.props.onOptionSelect, option.value);
            }
          }}
        >
          {option.label}
        </button>
      );
    });
  }

  render() {
    return <div>{this._renderOptions()}</div>;
  }
}

ToggleButtons.propTypes = {
  disabled: PropTypes.bool,
  // eslint-disable-next-line react/no-unused-prop-types
  name: PropTypes.string.isRequired, // used by implementing component, e.g. EmailPrefsPage
  onOptionSelect: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({ value: PropTypes.string, label: PropTypes.string }),
  ).isRequired,
  value: PropTypes.string,
};

ToggleButtons.defaultProps = {
  disabled: false,
  onOptionSelect: () => {},
  value: undefined,
};

export default ToggleButtons;
